import { useState } from 'react';

import { Button } from '@/design-system';

import { integrationsCopy as copy } from '../copy';

/** `true` als het klembord de tekst aannam. */
async function copyToClipboard(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);

        return true;
    } catch {
        return false;
    }
}

/**
 * Kopiëren, met een woord terug: "Gekopieerd", of waarom het niet lukte. Een knop die
 * stil faalt laat je een lege sleutel in je config plakken.
 */
export function CopyButton({ text, label = copy.copy }: { text: string; label?: string }) {
    const [result, setResult] = useState<'copied' | 'failed' | null>(null);

    return (
        <span className="inline-flex items-center gap-2">
            <Button
                variant="outline"
                size="xs"
                icon="copy"
                onClick={() => {
                    void copyToClipboard(text).then((ok) => setResult(ok ? 'copied' : 'failed'));
                }}
            >
                {label}
            </Button>
            <span role="status" className="text-[12px] leading-[1.4] text-[var(--accent-dark)]">
                {result === 'copied' ? copy.copied : null}
            </span>
            {result === 'failed' ? (
                <span role="alert" className="text-[12px] leading-[1.4] text-[var(--warn-text)]">
                    {copy.copyFailed}
                </span>
            ) : null}
        </span>
    );
}
